/** WP-125: registers the app-shell service worker in production builds only — dev
 * (`vite dev`) never registers it, so it can't shadow live-reloaded assets. */
export function registerServiceWorker(): void {
  if (!import.meta.env.PROD) return;
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  window.addEventListener("load", () => {
    void navigator.serviceWorker.register("/service-worker.js", { type: "module" });
  });
}
